module.exports = __webpack_public_path__ + "static/img/client1.ae0d450.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client1.png
// module id = L8pj
// module chunks = 1